import { DEFAULT_PANEL_SPAWN_POSITION } from "./panelSpawnConfig";

// Centralized configuration for property panels
export const PROPERTY_PANEL_CONFIG = {
  // Standard dimensions for all property panels
  dimensions: {
    width: 300,
    height: 620,
    minWidth: 220,
    minHeight: 300,
  },

  // Standard position
  position: DEFAULT_PANEL_SPAWN_POSITION,

  // Common styling
  styling: {
    backgroundColor: "var(--panel-surface)",
    backdropFilter: "blur(10px)",
    borderColor: "var(--panel-border)",
    borderRadius: "8px",
    shadow: "0 10px 25px rgba(0, 0, 0, 0.3)",
  },

  // Text colors
  colors: {
    primary: "var(--panel-text-primary)", // text-gray-100
    secondary: "var(--panel-text-secondary)", // text-gray-400
    helper: "var(--panel-text-helper)", // text-gray-300
    muted: "var(--panel-text-disabled)", // disabled/inactive text
    border: "#374151", // border-gray-700
  },

  // Animation settings
  animation: {
    transition: "opacity 0.3s ease",
    dragTransition: "all 0.2s ease",
  },
};

// Helper function to get standard panel props
export const getStandardPanelProps = (customProps = {}) => ({
  initialSize: PROPERTY_PANEL_CONFIG.dimensions,
  minWidth: PROPERTY_PANEL_CONFIG.dimensions.minWidth,
  minHeight: PROPERTY_PANEL_CONFIG.dimensions.minHeight,
  ...customProps,
});

// Helper function to get standard position
export const getStandardPosition = (customPosition = {}) => ({
  ...PROPERTY_PANEL_CONFIG.position,
  ...customPosition,
});

export default { PROPERTY_PANEL_CONFIG, getStandardPanelProps, getStandardPosition };
